import {createStore, compose} from 'redux';
import reducers from '../reducers';

import {applyMiddleware} from 'redux';

import thunk from 'redux-thunk';

// import history from '../services/history';

const middlewares = applyMiddleware(thunk);

const initialState = {};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancers = composeEnhancers(
    middlewares,
    // process.env.NODE_ENV != 'production' && window.devToolsExtension ? window.devToolsExtension() : f => f
);

export default createStore(reducers, initialState, enhancers);
